import { render } from "./PDFOnlineTypeBlockWorkDescription.vue?vue&type=template&id=e4442090&ts=true"
import script from "./PDFOnlineTypeBlockWorkDescription.vue?vue&type=script&lang=ts"
export * from "./PDFOnlineTypeBlockWorkDescription.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__